import {EventoObject} from "../../models/Evento";
import React from "react";
import truncate from 'lodash/truncate';
import {DateTime} from "luxon";
import {IonIcon} from "@ionic/react";
import {clipboard} from "ionicons/icons";
import {sanitizeText} from "../../lib/utils";

export const cardSubtitle = (i: EventoObject) => (
  <div className="flex items-baseline justify-between">
    <div>{i.tipo}</div>
    <div className="text-base font-bold">
      {DateTime.fromJSDate(i.data.toDate()).toFormat('dd/MM/yyyy')}
    </div>
  </div>
);

export const cardTitle = (i: EventoObject) => (
  <>
    {i.descricao}
  </>
);

export const cardContent = (i: EventoObject) => (
  <>
    <div>
      {truncate(sanitizeText(i.notas), {length: 100})}
    </div>
    {i.questionario &&
      <div className="flex justify-end">
        <IonIcon icon={clipboard} className="text-xl"/>
      </div>
    }
  </>
);
